var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "arview-popup" }, [
    _c(
      "div",
      {
        staticClass: "arview-wrapper",
        on: {
          mouseenter: function ($event) {
            _vm.showCloseButton = true
          },
          mouseleave: function ($event) {
            _vm.showCloseButton = false
          },
        },
      },
      [
        _c("iframe", {
          staticClass: "arview-iframe",
          style: _vm.arViewEmbedSize,
          attrs: { allow: "fullscreen", src: _vm.arViewUrl },
        }),
        _vm._v(" "),
        _vm.closeButtonVisible
          ? _c(
              "button",
              {
                staticClass: "close-marker-button",
                on: { click: _vm.closeMarkerInfo },
              },
              [_c("i", { staticClass: "isif isif-times" })]
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }